import Raven from 'raven-js';
import { useMemo } from 'react';
export default function useGetSubscriptionDefinition(subscriptionStatuses, selectedLanguage) {
  return useMemo(() => {
    const translatedSubscriptions = [];
    try {
      subscriptionStatuses.forEach(subscriptionStatus => {
        const availableTranslations = Object.keys(subscriptionStatus.translations);
        if (availableTranslations.includes(selectedLanguage)) {
          translatedSubscriptions.push(Object.assign({}, subscriptionStatus.translations[selectedLanguage], {
            id: subscriptionStatus.id
          }));
        } else {
          translatedSubscriptions.push(Object.assign({}, subscriptionStatus.translations[subscriptionStatus.primaryLanguage || ''], {
            id: subscriptionStatus.id
          }));
        }
      });
    } catch (err) {
      Raven.captureException(err, {
        extra: {
          location: 'hooks/getSubscriptionDefinition'
        }
      });
    }
    return translatedSubscriptions;
  }, [subscriptionStatuses, selectedLanguage]);
}